<template>
  <div class="result-screen" :class="{ rookie: (level==='rookie') }">
    <div class="container">
      <StatusBar />

      <div class="box-result bg-white rounded-xl md:py-8 md:px-8 py-6 px-6 mx-auto max-w-3xl">
        <img :src="`./images/${$i18n.locale}/${level}-${score}.svg`" class="mx-auto" :alt="`${level}-${score}`" />
        <h3
          class="mt-4"
          v-html="$t('result.your_score', { score: score, total: total })"
        ></h3>
        <h3 v-if="level === 'rookie'" v-html="$t('result.your_level', { level: $t('level.rookie') })"></h3>
        <div v-if="level === 'rookie'" class="space-y-4">
          <h1 v-html="$t('result.rookie.title')"></h1>
          <p v-html="$t('result.rookie.text1')" class="text-lg md:text-xl"></p>
          <p v-html="$t('result.rookie.text2')" class="text-md"></p>

          <div class="flex flex-col md:flex-row justify-center md:space-x-4 space-y-4 md:space-y-0">
            <button class="button button--yellow" @click="restart">
              <span v-html="$t('general.try_again')"></span>
              <span><img :src="`./images/icons/try-again-icon.svg`" alt="try-again" /></span>
            </button>
          </div>

          <p v-html="$t('result.rookie.text3')" class="text-md"></p>

          <div class="flex flex-col md:flex-row justify-center md:space-x-4 space-y-4 md:space-y-0">
            <button class="button button--brown" @click="freeCheck2()">
              <span v-html="$t('result.online_skin_check')"></span>
              <span><img :src="`./images/icons/skin-check-icon.svg`" alt="skin-check" /></span>
            </button>
            <button class="button button--yellow" @click="findDermato()">
              <span v-html="$t('result.find_dermato')"></span>
              <span><img :src="`./images/icons/find-icon.svg`" alt="find" /></span>
            </button>
          </div>
        </div>

        <h3 v-if="level === 'advanced'" v-html="$t('result.your_level', { level: $t('level.advanced') })"></h3>
        <div v-if="level === 'advanced'" class="space-y-4">
          <h1 v-html="$t('result.advanced.title')"></h1>
          <p v-html="$t('result.advanced.text1')" class="text-lg md:text-xl"></p>

          <div class="flex flex-col md:flex-row justify-center md:space-x-4 space-y-4 md:space-y-0">
            <button class="button button--yellow" @click="restart">
              <span v-html="$t('general.try_again')"></span>
              <span><img :src="`./images/icons/try-again-icon.svg`" alt="try-again" /></span>
            </button>
            <SoMeShare />
          </div>

          <p v-html="$t('result.advanced.text2')" class="text-md"></p>
          <p v-html="$t('result.advanced.text3')" class="text-md"></p>

          <div class="flex flex-col md:flex-row justify-center md:space-x-4 space-y-4 md:space-y-0">
            <button class="button button--brown" @click="freeCheck()">
              <span v-html="$t('result.free_online_skin_check')"></span>
              <span><img :src="`./images/icons/skin-check-icon.svg`" alt="skin-check" /></span>
            </button>
            <button class="button button--yellow" @click="findDermato()">
              <span v-html="$t('result.find_dermato')"></span>
              <span><img :src="`./images/icons/find-icon.svg`" alt="find" /></span>
            </button>
          </div>
        </div>

        <h3 v-if="level === 'expert'" v-html="$t('result.your_level', { level: $t('level.expert') })"></h3>
        <div v-if="level === 'expert'" class="space-y-4">
          <h1 v-html="$t('result.expert.title')"></h1>
          <p v-html="$t('result.expert.text1')" class="text-lg md:text-xl"></p>
          <p v-html="$t('result.expert.text2')" class="text-md"></p>
          <p v-html="$t('result.expert.text3')"></p>
          <div class="flex flex-col md:flex-row justify-center md:space-x-4 space-y-4 md:space-y-0">
            <button class="button button--brown" @click="freeCheck()">
              <span v-html="$t('result.free_online_skin_check')"></span>
              <span><img :src="`./images/icons/skin-check-icon.svg`" alt="skin-check" /></span>
            </button>
            <button class="button button--yellow" @click="findDermato()">
              <span v-html="$t('result.find_dermato')"></span>
              <span><img :src="`./images/icons/find-icon.svg`" alt="find" /></span>
            </button>
            <SoMeShare />
          </div>
        </div>
      </div>

      <ExternalModal :showing="externalModalShowing" @close="closeModal()">
        <div v-if="!externalDerma"><span v-html="$t('result.modal.text1')"></span><br />
          <span v-html="$t('result.modal.text2')"></span>
        </div>
        <div v-if="externalDerma"><span v-html="$t('result.modal.derma_text1')"></span><br />
          <span v-html="$t('result.modal.derma_text2')"></span>
        </div>
        <div class="flex flex-col md:flex-row justify-center md:space-x-4 space-y-4 md:space-y-0 pt-8">
          <button
            class="button button--yellow"
            @click="openExternalLink()"
            v-html="$t('result.modal.ok')"
          >
            OK
          </button>
          <button
            class="button button--brown"
            @click="closeModal()"
            v-html="$t('result.modal.cancel')"
          >
            Cancel
          </button>
        </div>
      </ExternalModal>
    </div>
  </div>
</template>

<script>
import StatusBar from "./StatusBar.vue";
import SoMeShare from "./SoMeShare.vue";
import ExternalModal from "./ExternalModal.vue";

export default {
  name: "ResultScreen",
  components: {
    StatusBar,
    SoMeShare,
    ExternalModal,
  },
  props: {
    level: String,
    levelProgress: Number,
    score: Number,
    total: Number,
  },
  data() {
    return {
      externalModalShowing: false,
      externalDerma: true,
      externalLink: null
    };
  },
  methods: {
    restart() {
      this.$emit("restart");
    },
    findDermato() {
      this.externalLink = this.$t('result.find_dermato_URL');
      this.externalDerma = false;
      this.externalModalShowing = true;
    },
    freeCheck() {
      this.externalLink = this.$t('result.expert.free_check_URL');
      this.externalDerma = true;
      this.externalModalShowing = true;
    },
    freeCheck2() {
      this.externalLink = this.$t('result.exclusive_check_URL');
      this.externalDerma = true;
      this.externalModalShowing = true;
    },
    closeModal() {
      this.externalModalShowing = false;
    },
    openExternalLink() {
      if (this.externalLink) {
        window.open(this.externalLink,'_blank').focus();
      }
      this.externalLink = null;
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.result-screen {
  background-image: url("~@/assets/images/background/bg-congrats.svg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100%;
  padding-bottom: 1rem;

  &.rookie {
    background-image: none;
  }
}

.box-result {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;

  @media (min-width: 768px){
    font-size: 4rem;
  }
}
</style>
